/**
 * Created by XUQIANG on 2016/4/7.
 */
const PromptInfo = {
  USERNAME_ISNULL: 'USERNAMEISNUMLL', //用户名为空
  PASSWORD_ISNULL: 'PASSWORDISNULL', //密码为空
  VERCODE_WRONG: 'VERCODEWRONG', //验证码错误
  REFRESH_CODE: 'REFRESHCODE', //刷新验证码
  USER_INVALID: 'USERINVALID', //登录失败
  USER_VALID: 'USERVALID' //登录成功
};

//弹出框的类型
const DialogType = {
  INFORMATION: 'INFORMATION',
  WARN: 'WARN',
  QUESTION: 'QUESTION',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  APP_ERROR: 'APP_ERROR'
};
//弹出框的结果
const DialogResult = {
  OK: 'OK',
  CANCEL: 'CANCEL',
  _NULL: '_NULL'
};

PromptInfo.DialogType = DialogType;
PromptInfo.DialogResult = DialogResult;
export default PromptInfo;



// WEBPACK FOOTER //
// ./src/utils/promptInfo.js